"use strict";
exports.__esModule = true;
exports.SvgToolbarZoomIn = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgToolbarZoomIn = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 20 20" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { fill: "currentColor", d: "M8.5 2a6.5 6.5 0 015.09 10.544l4.194 4.196a.739.739 0 01-1.044 1.044l-4.196-4.195A6.5 6.5 0 118.5 2zm0 1.5a5 5 0 10.001 10.001A5 5 0 008.5 3.5zm0 2.5a.75.75 0 01.75.75v1h1a.75.75 0 010 1.5h-1v1a.75.75 0 01-1.5 0v-1h-1a.75.75 0 010-1.5h1v-1A.75.75 0 018.5 6z" }),
        react_1["default"].createElement("path", { d: "M0 0h20v20H0z" })))); };
//# sourceMappingURL=ToolbarZoomIn.js.map